import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportFichaCadastralLgpdMedicoRequest, ReportFichaCadastralLgpdMedicoResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './ficha-cadastral-lgpd-medico.model';

/** Cliente HTTP do relatório assíncrono Ficha Cadastral LGPD (Médico). */
@Injectable({ providedIn: 'root' })
export class FichaCadastralLgpdMedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.fichaCadastralLgpdMedico;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportFichaCadastralLgpdMedicoRequest): Observable<HttpResponse<ReportFichaCadastralLgpdMedicoResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportFichaCadastralLgpdMedicoResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportFichaCadastralLgpdMedicoRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
